/* eslint-disable @typescript-eslint/no-unused-vars */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';

(function (angular) {
  angular.module('xplenty-designer').directive('designerPackageView', [
    '$timeout',
    '$rootScope',

    function ($timeout, $rootScope) {
      return {
        templateNamespace: 'html',
        restrict: 'E',
        // eslint-disable-next-line global-require
        template: require('./designer-package-view.html'),
        replace: true,
        scope: {
          designer: '=',
        },
        link(scope, element, attrs) {
          const $wrapper = element.find('.designer-package-view-wrapper');

          $wrapper.perfectScrollbar();
        },
        controller: [
          '$scope',
          function ($scope) {
            $scope.packageJson = {};
            $scope.collapsed = true;

            const setPackageData = function () {
              $scope.collapsed = true;
              $scope.packageJson = $scope.designer.package.getData();

              $scope.packageJson.data_flow_json = JSON.parse($scope.packageJson.data_flow_json);

              $timeout(function () {
                $scope.collapsed = false;
              });
            };

            $rootScope.$on(DESIGNER_EVENTS.PACKAGE_VARIABLES_UPDATE, setPackageData);
            $rootScope.$on(DESIGNER_EVENTS.PACKAGE_UPDATED, setPackageData);
            $rootScope.$on(DESIGNER_EVENTS.RESIZE, setPackageData);

            setPackageData();
          },
        ],
      };
    },
  ]);
})(window.angular);
